import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import { photoCredit, photoUrl } from '../cameraData';

/**
 * The camera photo, uncropped and as large as the modal allows. The detail
 * hero and hover cards crop to a square (object-fit: cover); this shows the
 * photo as uploaded.
 */
export default class CameraPhotoModal extends Modal {
  className() {
    return 'CameraPhotoModal';
  }

  title() {
    return this.attrs.camera.name;
  }

  content() {
    const credit = photoCredit(this.attrs.camera);

    return (
      <div className="Modal-body">
        <img className="CameraPhotoModal-img" src={photoUrl(this.attrs.camera)} alt={this.attrs.camera.name} />
        {credit && (
          <p className="CameraPhotoModal-credit">
            {credit.artist && <span>{credit.artist}</span>}
            {credit.artist && credit.license && ' · '}
            {credit.license &&
              (credit.licenseUrl ? (
                <a href={credit.licenseUrl} target="_blank" rel="noopener">
                  {credit.license}
                </a>
              ) : (
                <span>{credit.license}</span>
              ))}
            {(credit.artist || credit.license) && ' · '}
            <a href={credit.page} target="_blank" rel="noopener">
              via Wikimedia Commons
            </a>
          </p>
        )}
      </div>
    );
  }
}
